import { Component, OnDestroy, OnInit } from '@angular/core';
import { ConfigurationService } from '../../configurationService';
import { MenuItems, ObjectNames } from '../constants/constants';
import { ProductService } from '../product/product.service';
import { Subject, takeUntil } from 'rxjs';
import { AppMainService } from 'src/app/app-main.service';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss']
})
export class ProductComponent implements OnInit, OnDestroy {

  inventoryTypeConfig;
  inventoryTypeTemplateConfig;
  allInventoryTypeJSON;
  allInventoryTypeTemplateJSON;
  allInventoryTypes = [];
  allInventoryStages = [];
  allInventoryTemplates = [];
  allInventorySections = [];
  configMenuInventoryItems = [];
  index = 0;
  channelTypeId;
  templateTypeId;
  sectionTypeId;

  //product visibility
  displayAddGroup: boolean = false;
  visibilityStatus: boolean = false;
  protected ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(private service: ConfigurationService, private productConfigService: ProductService,
    private appMainService: AppMainService) { }

  ngOnInit(): void {
    this.loadProductConfigurations('product');
    this.loadISettings();
  }

  buildMenu() {
    this.configMenuInventoryItems = [
      {
        label: MenuItems.Category,
        icon: 'pi pi-plus',
        command: () => {
          this.showAddCategory();
        }
      },
      {
        label: MenuItems.Field,
        icon: 'pi pi-plus',
        command: () => {
          this.showAddProductData();
        }
      },
      {
        label: MenuItems.Visibility,
        icon: 'pi pi-plus',
        visible: this.visibilityStatus,
        command: () => {
          this.index = 4;
          this.displayAddGroup = true;
        }
      }
    ];
  }

  loadISettings() {
    this.appMainService.isShowSpinner("setting");
    this.productConfigService.loadISettings().pipe(takeUntil(this.ngUnsubscribe$)).subscribe((iSettings) => {
      this.visibilityStatus = iSettings?.find(set => set.code == ObjectNames.productConstants.productVisibility?.toLowerCase().replace(/ /g, ""))?.enabled;
      this.appMainService.isHideSpinner("setting");
      this.buildMenu();
    })
  }

  getIndex(event) {
    this.index = event.index;
    this.displayAddGroup = false;
  }

  showAddProductData() {
    this.productConfigService.setProductField(ObjectNames.BehaviorSubjectVariable);
    this.index = 3;
  }

  showAddCategory() {
    this.index = 1;
    this.productConfigService.setProductCategory(ObjectNames.BehaviorSubjectVariable);
  }

  loadProductConfigurations(moduleName) {
    this.service.getConfigurationByModuleName(moduleName).subscribe(config => {
      //Inventory Product Types
      this.inventoryTypeConfig = config.filter(s => s.name == ObjectNames.productConstants.Inventory_Types_Object)[0];
      this.allInventoryTypes = (this.inventoryTypeConfig && this.inventoryTypeConfig.configurationDetails && this.inventoryTypeConfig.configurationDetails[0].configJSONValue != "" ? JSON.parse(this.inventoryTypeConfig.configurationDetails[0].configJSONValue) : []);

      // //kit
      // this.allInventoryTypes.push({id:100,name:"Kit/Package Items",isActive:true});
      // console.log(this.allInventoryTypes)

      //Inventory Product Templates
      this.inventoryTypeTemplateConfig = config.filter(s => (s.name == ObjectNames.productConstants.Inventory_Template_Object && s.categoryId == 6))[0];
      this.allInventoryTemplates = (this.inventoryTypeTemplateConfig && this.inventoryTypeTemplateConfig.configurationDetails && this.inventoryTypeTemplateConfig.configurationDetails[0].configJSONValue != "" ? JSON.parse(this.inventoryTypeTemplateConfig.configurationDetails[0].configJSONValue) : []);

      //  //kit
      //   this.allInventoryTemplates.push({id:100,templateName:"Kit/Package Items_Template",isActive:true,producttype:{id:100,name:"Kit/Package Items"}});
      //  console.log(this.allInventoryTemplates)

      //Inventory Product Sections
      const inventoryTypeSectionConfig = config.filter(s => s.name == ObjectNames.customConstants.Inventory_Section_Object)[0];
      this.allInventorySections = (inventoryTypeSectionConfig && inventoryTypeSectionConfig.configurationDetails && inventoryTypeSectionConfig.configurationDetails[0].configJSONValue != "" ? JSON.parse(inventoryTypeSectionConfig.configurationDetails[0].configJSONValue) : []);
    })
  }

  closeDialog(){
    this.displayAddGroup = false;
  }

  ngOnDestroy(): void {
    if (this.ngUnsubscribe$) {
      this.ngUnsubscribe$.next();
      this.ngUnsubscribe$.complete();
      this.ngUnsubscribe$.unsubscribe();
    }
  }

}
